/**
 * Shared time constants used across multiple controllers
 */
export const TIME_RANGES = {
    MORNING: "08:00-12:00",
    AFTERNOON: "13:00-17:00",
    FULL_DAY: "08:00-17:00"
} as const;

export const BUSINESS_HOURS = {
    START: "08:00",
    LUNCH_START: "12:00",
    LUNCH_END: "13:00",
    END: "17:00"
} as const;

export const DEFAULT_EVENT_ID = "68ef5b6f-40bd-4eea-b970-45dfa6213279";
